var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeChildren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41359",
    "data-name": "Group 41359",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12990",
    "data-name": "Rectangle 12990",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M.889,8A.889.889,0,0,1,0,7.111V.889a.889.889,0,1,1,1.778,0V6.223H7.111A.889.889,0,1,1,7.111,8Z",
    transform: "translate(6 2)",
    fill: "#b2b9c4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeChildren);
export default __webpack_public_path__ + "static/media/tree-children.2f8441d96411ebdbadd4dedb90b046df.svg";
export { ForwardRef as ReactComponent };